import React from 'react';
import { Box, Skeleton, useTheme } from '@ublend-npm/aulaui-core';

export const OutlookEmailDetailSkeleton = () => {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      flexDirection="column"
      flex={1}
      minHeight={0}
      gap={2}
      width="100%"
      sx={{ pt: { xs: 1, sm: 2 } }}
      bgcolor={theme.palette.background.paper}
      borderRadius={2}
      p={2}
    >
      {/* Subject line skeleton */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        gap={2}
        sx={{ pr: 4, flexWrap: 'wrap' }}
      >
        <Skeleton kind="text" width="70%" height={32} />
      </Box>

      {/* Message Card Skeleton */}
      <Box
        sx={{
          width: '100%',
          boxSizing: 'border-box',
          borderRadius: 2,
          p: { xs: 1.5, sm: 3 },
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        {/* Header: Avatar, Sender, Date, Recipient */}
        <Box display="flex" alignItems="flex-start" gap={2} width="100%">
          <Skeleton kind="circular" width={40} height={40} />
          <Box
            flex={1}
            minWidth={0}
            display="flex"
            flexDirection="column"
            gap={0.5}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              width="100%"
            >
              <Skeleton kind="text" width="35%" height={20} />
              <Skeleton kind="text" width="18%" height={16} />
            </Box>
            <Skeleton kind="text" width="45%" height={16} />
          </Box>
        </Box>

        {/* Body content lines */}
        <Box display="flex" flexDirection="column" gap={1.2} mt={1}>
          <Skeleton kind="text" width="95%" height={18} />
          <Skeleton kind="text" width="90%" height={18} />
          <Skeleton kind="text" width="85%" height={18} />
          <Skeleton kind="text" width="70%" height={18} />
          <Skeleton kind="text" width="40%" height={18} />
        </Box>

        {/* Action Button Skeleton */}
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Skeleton
            kind="rounded"
            width={140}
            height={36}
            sx={{ borderRadius: '8px' }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default OutlookEmailDetailSkeleton;
